import React from "react";
import StyledSvgSprite from "@/components/Atoms/SVGSprite";
import Image from "@/components/Atoms/Image";

import { StyledImageBox } from "./style";

function ImageBox({
  icon,
  src,
  height,
  width,
  alt,
  fill,
  maxHeight = "100%",
  maxWidth = "100%",
  objectFit = "cover",
  ...rest
}: any) {
  return icon ? (
    <StyledSvgSprite
      icon={icon}
      height={height}
      width={width}
      fill={fill}
      {...rest}
    />
  ) : (
    <StyledImageBox
      height={height || "100%"}
      width={width || "100%"}
      maxHeight={maxHeight}
      maxWidth={maxWidth}
      objectFit={objectFit}
      {...rest}
    >
      <Image src={src} alt={alt || "image-box"} />
    </StyledImageBox>
  );
}

export default ImageBox;
